import { atom } from 'recoil';
import { LegacyTask } from '../../interfaces/api/Collaborative';

export default atom({
  key: 'tasks',
  default: {} as { [key: string]: LegacyTask },
});
